export default __webpack_public_path__ + "static/media/level.35cc4276.svg";